var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalityInPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39999 9.60008C8.16479 9.60008 9.59998 8.16487 9.59998 6.40005C9.59998 4.63524 8.16479 3.20003 6.39999 3.20003C4.63519 3.20003 3.19999 4.63524 3.19999 6.40005C3.19999 8.16487 4.63519 9.60008 6.39999 9.60008ZM6.39999 4.80004C7.28239 4.80004 7.99999 5.51764 7.99999 6.40005C7.99999 7.28246 7.28239 8.00006 6.39999 8.00006C5.51759 8.00006 4.79999 7.28246 4.79999 6.40005C4.79999 5.51764 5.51759 4.80004 6.39999 4.80004Z",
    fill: "#62666C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93606 15.8513C6.07146 15.948 6.23368 16 6.40006 16C6.56644 16 6.72866 15.948 6.86406 15.8513C7.10726 15.6793 12.8232 11.5521 12.8 6.40005C12.8 2.87122 9.92885 0 6.40006 0C2.87127 0 7.043e-05 2.87122 7.043e-05 6.39605C-0.0231295 11.5521 5.69286 15.6793 5.93606 15.8513ZM6.40006 1.60001C9.04725 1.60001 11.2001 3.75283 11.2001 6.40405C11.2169 9.95448 7.68966 13.1425 6.40006 14.1881C5.11126 13.1417 1.58327 9.95288 1.60007 6.40005C1.60007 3.75283 3.75286 1.60001 6.40006 1.60001Z",
    fill: "#62666C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalityInPerson);
export default __webpack_public_path__ + "static/media/ModalityInPerson.5802573077a241a3b9fe786c6b9c6a8a.svg";
export { ForwardRef as ReactComponent };